import LazyAdaptedSignedInContainer from "@pathwright/features/src/modules/auth/LazyAdaptedSignedInContainer"
import NextRegisterStateButton from "./NextRegisterStateButton"

const SignedInFooter = function ({
  attemptToConvert,
  offerConversionActionLabel
}) {
  return (
    <div
      className="SignedInFooter"
      style={{ textAlign: "center", padding: "0 20px 20px" }}
    >
      <LazyAdaptedSignedInContainer size="lg" />
      <NextRegisterStateButton
        attemptToConvert={attemptToConvert}
        offerConversionActionLabel={offerConversionActionLabel}
      />
    </div>
  )
}

SignedInFooter.displayName = "SignedInFooter"

export default SignedInFooter
